document.addEventListener("DOMContentLoaded", () => {
  const burgerMenu = document.querySelector(".Burger_Menu");
  const burgerMenuButton = document.querySelector(".Burger_Menu_Button");

  if (!burgerMenu || !burgerMenuButton) return;

  burgerMenuButton.addEventListener("click", () => {
    burgerMenu.classList.toggle("Open");
    burgerMenuButton.classList.toggle("Open");
  });

  const sublinkLists = document.querySelectorAll(".Menu_Mobile_Sub_List");
  sublinkLists.forEach((list) => {
    const sublinkButton = list.previousElementSibling.closest("li");
    list.style.setProperty("--height", `${list.scrollHeight}px`);

    let cd = false;

    sublinkButton.addEventListener("click", (e) => {
      if (e.target != sublinkButton.querySelector(".Menu_Mobile_Link")) return;

      if (!list.classList.contains("Open") || !cd) {
        e.preventDefault();
      } else {
        return;
      }

      cd = true;
      setTimeout(() => {
        cd = false;
      }, 300); // make this a timer to allow double click to open parent link (500 for instance)

      list.classList.toggle("Open");
    });
  });
});
